import React, { useState } from "react";
import { X } from "lucide-react";
import { apiDelete } from "../../API/Api_Url";
import { toast } from "react-toastify";

function FreelancerDeleteTrackerModal({ isOpen, onClose, selectedRequestId, selectedTracker, GetAllAssignedJobPosts }) {

    const [isDeleting, setIsDeleting] = useState(false);

    const confirmDelete = async () => {
        try {
            setIsDeleting(true);
            const response = await apiDelete(`api/freelance-engineer/DeleteJobPostTracker/${selectedRequestId}/${selectedTracker?._id}`);

            if (response) {
                toast.success("Tracker deleted successfully!");
                onClose()
                GetAllAssignedJobPosts();
            } else {
                toast.error(response?.message || "Failed to update requirement");
            }
        } catch (error) {
            console.error("Error updating requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsDeleting(false);
        }
    };



    if (!isOpen) return null;


    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6 relative">
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                >
                    <X className="w-5 h-5" />
                </button>

                <h2 className="text-lg font-semibold text-gray-800 mb-4">
                    Delete Tracker
                </h2>

                <p className="text-sm text-gray-700 mb-6">
                    Are you sure you want to delete the tracker{" "}
                    <span className="font-medium">{selectedTracker?.Title}</span>? This action cannot be undone.
                </p>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg border text-sm text-gray-700 hover:bg-gray-100"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={confirmDelete}
                        disabled={isDeleting}
                        className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm hover:bg-red-700 disabled:opacity-50"
                    >
                        {isDeleting ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FreelancerDeleteTrackerModal;
